// import React, { useState, useEffect } from "react";
// import "./HeroSection.css";

// import Banner1 from "../Images/Banner1.webp";
// import Banner2 from "../Images/Banner2.webp";
// import Banner3 from "../Images/Banner3.webp";

// const images = [Banner1, Banner2, Banner3];

// const HeroSection = () => {
//   const [current, setCurrent] = useState(0);

//   // Auto slide every 5 seconds
//   useEffect(() => {
//     const interval = setInterval(() => {
//       nextSlide();
//     }, 5000);
//     return () => clearInterval(interval);
//   }, [current]);

//   const nextSlide = () => {
//     setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
//   };

//   const prevSlide = () => {
//     setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
//   };

//   return (
//     <section className="hero-slider" id="home">
//       {images.map((img, index) => (
//         <div
//           key={index}
//           className={`slide ${index === current ? "active" : ""}`}
//           style={{ backgroundImage: `url(${img})` }}
//         >
         
//         </div>
//       ))}

//       {/* Navigation Arrows */}
//       <button className="arrow left" onClick={prevSlide}>
//         &#10094;
//       </button>
//       <button className="arrow right" onClick={nextSlide}>
//         &#10095;
//       </button>

//       {/* Dots */}
//       <div className="dots">
//         {images.map((_, index) => (
//           <span
//             key={index}
//             className={`dot ${index === current ? "active" : ""}`}
//             onClick={() => setCurrent(index)}
//           ></span>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default HeroSection;

import React, { useState, useEffect } from "react";
import "./HeroSection.css";

const HeroSection = () => {
  const [banners, setBanners] = useState([]);
  const [current, setCurrent] = useState(0);

  // Fetch banners from the API
  // Fetch banners from the API
  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await fetch("https://api.garudasena.org/api/banners");
        const data = await response.json();

        // Filter banners for "Hero Section"
        const heroBanners = data.filter(banner => banner.section === "Hero Section");
        setBanners(heroBanners); // Set the fetched hero section banners
      } catch (error) {
        console.error("Error fetching banners:", error);
      }
    };

    fetchBanners();
  }, []);

  // Auto slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, [current]);

  const nextSlide = () => {
    setCurrent((prev) => (prev === banners.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? banners.length - 1 : prev - 1));
  };

  return (
    <section className="hero-slider" id="home">
      {/* Loop over the banners fetched from the API */}
      {banners.map((banner, index) => (
        <div
          key={banner.id} // Use the banner's unique ID for the key
          className={`slide ${index === current ? "active" : ""}`}
          style={{ backgroundImage: `url(${banner.image})` }}
        >
          {/* Optionally, you can add a caption or overlay here */}
       
        </div>
      ))}

      {/* Navigation Arrows */}
      <button className="arrow left" onClick={prevSlide}>
        &#10094;
      </button>
      <button className="arrow right" onClick={nextSlide}>
        &#10095;
      </button>

      {/* Dots */}
      <div className="dots">
        {banners.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === current ? "active" : ""}`}
            onClick={() => setCurrent(index)}
          ></span>
        ))}
      </div>
    </section>
  );
};

export default HeroSection;

